import React from 'react'
import { createRoot } from 'react-dom/client'

import LandingPage from './LandingPage'

document.addEventListener("turbolinks:load", () => {
  const forBrandsComponent = document.getElementById('ForBrandsComponent')
  if (forBrandsComponent) {
    const ForBrandsRoot = createRoot(forBrandsComponent)
    ForBrandsRoot.render(<LandingPage />)
  }
})

